import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";
import type { ExtraTab } from "@/components/Templates/types";
import { MetricsTab } from "./MetricsTab";

export default function AdverseEvents({
  singleSubjectId,
}: {
  readonly singleSubjectId?: string;
}) {
  const { id } = useScopeParams();
  const wikiLink = singleSubjectId
    ? "/wiki/guides/exploration-singlesubject-subject-ae"
    : "/wiki/guides/exploration-safety-adverse-events";

  const extraTabs: ExtraTab[] = [
    {
      type: "custom",
      key: "metrics",
      title: "Metrics",
      component: MetricsTab,
      toolbar: {
        showOnly: ["guide"],
      },
    },
  ];

  return (
    <PageTemplate
      title="Safety: Adverse Events"
      tooltipText="Explore enrolled subjects' adverse events (AEs) data, by all AEs, special interest AEs, and serious AEs."
      type="adverse_events"
      constants={{
        wikiLink,
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/adverse-events`,
      }}
      subjectId={singleSubjectId}
      extraTabs={singleSubjectId ? [] : extraTabs}
    />
  );
}
